<template>
  <q-dialog :model-value="modelValue" persistent @update:model-value="$emit('update:modelValue', $event)">
    <q-card style="min-width: 900px; max-width: 1100px;">
      <q-card-section class="row items-center q-pb-none">
        <div class="text-h6">Выбор проекта УСП</div>
        <q-space />
        <q-btn
          icon="sync" label="Обновить список"
          flat dense
          :loading="isIngesting"
          @click="$emit('ingest')"
          class="q-mr-sm"
        />
        <q-btn icon="close" flat round dense @click="$emit('update:modelValue', false)" />
      </q-card-section>
      <q-card-section>
        <q-input
          v-model="search"
          outlined dense clearable autofocus
          placeholder="Поиск по названию / типу / guid..."
        >
          <template v-slot:prepend><q-icon name="search" /></template>
        </q-input>
        <q-separator spaced />
        <q-linear-progress v-if="isLoading" indeterminate />
        <div v-else class="project-list">
          <q-item
            v-for="p in filtered"
            :key="p.project_guid"
            clickable v-ripple
            @click="$emit('select', p)"
          >
            <q-item-section>
              <q-item-label>{{ p.project_name }}</q-item-label>
              <q-item-label caption>
                {{ p.project_type }} · <span class="mono">{{ p.project_guid }}</span>
              </q-item-label>
            </q-item-section>
            <q-item-section side><q-icon name="chevron_right" /></q-item-section>
          </q-item>
          <div v-if="filtered.length === 0" class="text-center text-grey-6 q-pa-md">
            Ничего не найдено
          </div>
        </div>
      </q-card-section>
    </q-card>
  </q-dialog>
</template>

<script>
export default {
  name: 'PpmProjectDialog',
  props: {
    modelValue: Boolean,
    projects: { type: Array, default: () => [] },
    isLoading: Boolean,
    isIngesting: Boolean,
  },
  emits: ['update:modelValue', 'select', 'ingest'],
  data() {
    return { search: '' };
  },
  computed: {
    filtered() {
      if (!this.search) return this.projects;
      const q = this.search.toLowerCase();
      return this.projects.filter(
        (p) =>
          p.project_name?.toLowerCase().includes(q) ||
          p.project_type?.toLowerCase().includes(q) ||
          p.project_guid?.toLowerCase().includes(q)
      );
    },
  },
};
</script>

<style scoped>
.project-list {
  max-height: 60vh;
  overflow-y: auto;
}
.mono {
  font-family: monospace;
  font-size: 12px;
  color: #78909c;
}
</style>
